import React, { useState, useEffect } from "react";
import { X, Mail, UserPlus, Calendar, Save } from "lucide-react";
import "./Recommandationcooptation.css";

const RecommandationCooptationModal = ({ open, onClose, demande }) => {
    // ✅ hooks avant return
    const [activeMode, setActiveMode] = useState("recommandation");
    const [envoiDate, setEnvoiDate] = useState(new Date().toISOString().split("T")[0]);
    const [limitDate, setLimitDate] = useState(
        new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString().split("T")[0]
    );

    useEffect(() => {
        if (!open) return;
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = "unset";
        };
    }, [open]);

    if (!open || !demande) return null;

    const handleSave = () => {
        const formData = {
            demandeId: demande.id,
            type: activeMode,
            envoiDate,
            limitDate,
            poste: demande.poste,
        };

        console.log(
            `Email ${activeMode === "recommandation" ? "de Recommandation" : "de Cooptation"} envoyé:`,
            formData
        );

        alert(
            `Email ${
                activeMode === "recommandation" ? "de recommandation" : "de cooptation"
            } programmé pour le ${new Date(envoiDate).toLocaleDateString("fr-FR")}`
        );

        onClose();
    };

    const title =
        activeMode === "recommandation" ? "Email de recommandation" : "Email de cooptation";

    return (
        <div className="rcModal" onMouseDown={onClose} role="dialog" aria-modal="true">
            <div className="rcModal__panel" onMouseDown={(e) => e.stopPropagation()}>
                {/* Header (style sm) */}
                <div className="rcModal__header">
                    <div className="rcModal__title">
                        {activeMode === "recommandation" ? <Mail size={18} /> : <UserPlus size={18} />}
                        {title}
                    </div>

                    <button className="rcIconBtn" onClick={onClose} aria-label="Fermer">
                        <X size={18} />
                    </button>
                </div>

                {/* Tabs (visuellement alignés au style sm) */}
                <div className="rcTabs">
                    <button
                        type="button"
                        className={`rcTab ${activeMode === "recommandation" ? "rcTab--active" : ""}`}
                        onClick={() => setActiveMode("recommandation")}
                    >
                        <Mail size={16} />
                        <span>Recommandation</span>
                    </button>

                    <button
                        type="button"
                        className={`rcTab ${activeMode === "cooptation" ? "rcTab--active" : ""}`}
                        onClick={() => setActiveMode("cooptation")}
                    >
                        <UserPlus size={16} />
                        <span>Cooptation</span>
                    </button>
                </div>

                <div className="rcModal__body">
                    {/* Demande concernée (section style sm) */}
                    <div className="rcSection">
                        <div className="rcSection__title">
                            <UserPlus size={16} />
                            Demande concernée
                        </div>

                        <div className="rcInfoGrid">
                            <div className="rcInfoItem">
                                <span className="rcInfoLabel">Poste</span>
                                <span className="rcInfoValue">{demande.poste}</span>
                            </div>

                            <div className="rcInfoItem">
                                <span className="rcInfoLabel">Demandeur</span>
                                <span className="rcInfoValue">
                  {demande.firstname} {demande.lastname}
                </span>
                            </div>

                            <div className="rcInfoItem">
                                <span className="rcInfoLabel">Type d'emploi</span>
                                <span className="rcInfoValue">{demande.typeEmploi}</span>
                            </div>

                            <div className="rcInfoItem">
                                <span className="rcInfoLabel">Expérience requise</span>
                                <span className="rcInfoValue">{demande.anneesExperience}</span>
                            </div>
                        </div>
                    </div>

                    {/* Description (section style sm) */}
                    <div className="rcSection">
                        <div className="rcSection__title">
                            {activeMode === "recommandation" ? <Mail size={16} /> : <UserPlus size={16} />}
                            {activeMode === "recommandation"
                                ? "Contenu — Email de Recommandation"
                                : "Contenu — Email de Cooptation"}
                        </div>

                        <div className="rcCardText">
                            <p className="rcDescText">
                                {activeMode === "recommandation"
                                    ? "Envoyez un email aux collaborateurs pour leur demander de recommander des candidats qualifiés pour ce poste. L'email contiendra les détails du poste et un lien pour soumettre des recommandations."
                                    : "Envoyez un email aux collaborateurs pour les inviter à coopter des candidats de leur réseau. Ils recevront les détails du poste et pourront proposer directement des profils intéressants."}
                            </p>
                        </div>
                    </div>

                    {/* Dates (inputs style sm) */}
                    <div className="rcSection">
                        <div className="rcSection__title">
                            <Calendar size={16} />
                            Planification de l'envoi
                        </div>

                        <div className="rcGrid">
                            <div className="rcField">
                                <label>Date d'envoi de l'email</label>
                                <input
                                    type="date"
                                    value={envoiDate}
                                    onChange={(e) => setEnvoiDate(e.target.value)}
                                    min={new Date().toISOString().split("T")[0]}
                                />
                            </div>

                            <div className="rcField">
                                <label>Date limite de réponse</label>
                                <input
                                    type="date"
                                    value={limitDate}
                                    onChange={(e) => setLimitDate(e.target.value)}
                                    min={envoiDate}
                                />
                            </div>
                        </div>

                        <div className="rcInfoBox">
                            <strong>📅 Récapitulatif:</strong> L'email sera envoyé le{" "}
                            <strong>{new Date(envoiDate).toLocaleDateString("fr-FR")}</strong> et les
                            collaborateurs auront jusqu'au{" "}
                            <strong>{new Date(limitDate).toLocaleDateString("fr-FR")}</strong> pour répondre.
                        </div>
                    </div>
                </div>

                {/* Footer boutons style sm */}
                <div className="rcModal__footer">
                    <button className="rcBtn rcBtn--ghost" onClick={onClose} type="button">
                        Annuler
                    </button>

                    <button className="rcBtn rcBtn--primary" onClick={handleSave} type="button">
                        <Save size={16} />
                        Planifier l'envoi
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RecommandationCooptationModal;
